import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode } from 'react';
import { AiActivityPanel } from '../../features/ai/components/ai-activity-panel';
import { ProgressReviewIndicator } from '../../features/git/components/progress-review-indicator';

/**
 * Trợ lý AI, dạng **trang** — APM-MBAR-j.
 *
 * Trên điện thoại ô Trợ lý AI ở thanh dưới dẫn tới đây thay vì mở lớp phủ, như
 * ô Thông báo dẫn tới `/notifications` (APM-MBAR-g): có URL thì nút Quay lại
 * của điện thoại đưa người dùng về chỗ cũ, và lịch sử trình duyệt ghi nhận nó.
 *
 * Nội dung là **cùng một** `AiActivityPanel` với cột phải ở máy tính — lượt
 * đang chạy, câu hỏi chờ trả lời, lịch sử lượt cũ đều đọc từ `aiRunStore`, nên
 * mở trang giữa chừng một lượt chạy vẫn thấy đúng lượt ấy.
 *
 * Không đòi quyền gì: nội dung là run **của chính người xem**, lọc ở repository
 * (luật #5), và chưa cấu hình AI là trạng thái hợp lệ — danh sách rỗng.
 */
export const Route = createFileRoute('/_app/assistant')({
  component: AssistantPage,
});

function AssistantPage(): ReactNode {
  return (
    <>
      {/* Điện thoại không có thanh trên — chữ (i) của lượt AI rà commit ngầm nằm ở đây (APM-PCRV). */}
      <div className="flex justify-end empty:hidden">
        <ProgressReviewIndicator variant="page" />
      </div>
      <AiActivityPanel variant="page" />
    </>
  );
}
